import { useMemo } from 'react';
import find from 'lodash/find';

import channelsConfigurationResource from 'src/actions/channels/channelsConfigurationResource';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import routingGroupsResource from 'src/actions/routingGroups/routingGroupsResource';
import { useDocumentResourceAll } from 'src/presentation/hooks/useDocumentResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

const useDefaultConfiguration = (endpointType: EndpointTypes) => {
  const { value: channelConfiguration } = useDocumentResourceAll(channelsConfigurationResource);

  const { values: routingGroups } = useResourceValues(routingGroupsResource);

  return useMemo(() => {
    if (Object.keys(channelConfiguration).length) {
      const config = channelConfiguration[endpointType];

      const inbox = find(routingGroups, { id: config.defaultInbox });

      return { inboxName: inbox?.name, routingGroupId: config.defaultInbox, slaSeconds: config.defaultSLASeconds };
    }

    return { routingGroupId: '', slaSeconds: 0, inboxName: '' };
  }, [channelConfiguration, endpointType, routingGroups]);
};

export default useDefaultConfiguration;
